export default {
    letterSpacings: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em'
    },
    lineHeights: {
        normal: 'normal',
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: '2',
        3: '.75rem',
        4: '1rem',
        5: '1.3125rem',
        6: '1.5rem',
        7: '1.6875rem',
        8: '1.875rem',
        9: '2.25rem',
        10: '2.5rem',
        11: '2.8125rem',
        12: '3rem',
        13: '3.25rem',
        14: '3.5rem',
        15: '3.75rem',
        16: '4rem',
        17: '4.1875rem',
        18: '4.5rem',
        19: '4.875rem',
        25: '7.5rem'
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 500,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: `ContiStagSans, Helvetica, Arial, sans-serif`,
        body: `ContiStagSans, Helvetica, Arial, sans-serif`,
        mono: `ContiStagSans, Helvetica, Arial, sans-serif`
    },
    fontSizes: {
        xxs: '0.5rem', // 8px
        xs: '0.75rem', // 12px
        sm: '0.875rem', // 14px
        md: '1rem', // 16px
        lg: '1.125rem', // 18px
        xl: '1.25rem', // 20px
        '2xl': '1.5rem', // 24px
        '3xl': '2rem', // 32px
        '4xl': '2.5rem', // 40px
        '5xl': '3rem', // 48px
        '6xl': '3.75rem', // 60px
        '7xl': '4rem',
        '8xl': '5.5rem',
        '9xl': '7.5rem' // 120px
    }
}
